const ACCORDION_REDUCED_MOTION = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const collapseAccordion = (body, header) => {
    // Pin the current rendered height (body rests at "auto" once open) so the close animates
    body.style.height = `${body.scrollHeight}px`;
    body.offsetHeight; // force reflow before switching to 0
    body.classList.remove("expanded");
    header.classList.remove("open");
    body.style.height = "0px";
};

const expandAccordion = (body, header) => {
    body.classList.add("expanded");
    header.classList.add("open");
    // Without transitions, transitionend never fires, so settle at auto immediately
    body.style.height = ACCORDION_REDUCED_MOTION ? "auto" : `${body.scrollHeight}px`;
};

const handleClick = (a, c, allAccordions) => {
    // Loop through all accordions and collapse others
    allAccordions.forEach(accordion => {
        const body = accordion.querySelector("[data-accordion-layout-body]");
        const header = accordion.querySelector("[data-accordion-layout-header]");

        if (body !== a && body.classList.contains("expanded")) {
            collapseAccordion(body, header);
        }
    });

    // Toggle the current accordion
    if (a.classList.contains("expanded")) {
        collapseAccordion(a, c);
    } else {
        expandAccordion(a, c);
    }
};

const accordionsInit = () => {
    const allAccordions = [...document.querySelectorAll("[data-accordion-layout]")]; // Get all accordion containers

    allAccordions.forEach(b => {
        const c = b.querySelector("[data-accordion-layout-header]"), // The accordion header
              a = b.querySelector("[data-accordion-layout-body]"), // The accordion body
              d = b.querySelector("input"); // Checkbox input

        a.classList.remove("css-only");

        // Initially set height to 0px (collapse the body)
        a.style.height = "0px";

        // Once fully open, let the body size itself so late-loading images/fonts never clip
        a.addEventListener("transitionend", e => {
            if (e.target === a && e.propertyName === "height" && a.classList.contains("expanded")) {
                a.style.height = "auto";
            }
        });

        // Check if the accordion should be open on load (if data-accordion is "true")
        if (d && d.getAttribute("data-accordion") === "true") {
            a.style.height = "auto"; // Render open immediately, no load animation
            a.classList.add("expanded");
            c.classList.add("open");
        }

        // Set up the click event listener on the accordion header
        c.addEventListener("click", () => handleClick(a, c, allAccordions));
    });
};

// Initialize the accordions after the document is loaded
document.addEventListener("DOMContentLoaded", () => {
    accordionsInit();
});
